import React, { useEffect, useState } from "react"
import ModalAlert from "../ModalAlert"
import Send from "../../core/communication"
import { setQueueRemoveData } from "../../core/redux/offline/Actions"
import { store } from "../../core/redux"
import Swal from "sweetalert2"
import "./styles.scss"

const SendOfflineData = () => {
  const [offlineData, setOfflineData] = useState([])

  const data = store.getState().queue?.dataToSend

  useEffect(() => {
    if (data?.length > 0) {
      setOfflineData(data)
    }
  }, [data])

  const sendDataToServer = async (url, data) => {
    try {
      await Send.post(url, data)
      return true
    } catch (error) {
      Swal.fire({
        title: "Erro!",
        text: "Houve uma falha ao salvar o formulário, tente novamente.",
        icon: "error",
        showConfirmButton: false,
        timer: 3000,
      })
      return false
    }
  }

  const handleSave = async () => {
    if (!offlineData || offlineData.length === 0) return

    Swal.fire({
      title: "Enviando...",
      text: "Aguarde enquanto enviamos seus formulários salvos",
      allowOutsideClick: false,
      didOpen: () => Swal.showLoading(),
    })

    for (let index = 0; index < offlineData.length; ) {
      const { data, url } = offlineData[index]
      const success = await sendDataToServer(url, data)

      if (success) {
        offlineData.splice(index, 1)
        store.dispatch(setQueueRemoveData({ index, data }))
        Swal.update({ text: `Enviando... (${offlineData.length} restantes)` })
      } else {
        break
      }
    }

    Swal.close()

    if (offlineData.length === 0) {
      Swal.fire({
        title: "Sucesso!",
        text: "Todos os formulários foram salvos com sucesso.",
        icon: "success",
        showConfirmButton: false,
        timer: 3000,
      })
      setOfflineData([])
    }
  }

  const handleButtonClick = () => {
    ModalAlert.warn({
      title: "Deseja enviar?",
      confirmLabel: "Confirmar",
      text: `Você tem ${offlineData?.length} formulário(s) para enviar!`,
      onConfirm: handleSave,
    })
  }

  if(offlineData?.length === 0){
    return <></>
  }

  return (
      <button onClick={handleButtonClick} className="cache-itens-send">
        <i className="fi fi-rr-cloud-upload"></i>
        <div className="cache-itens-send-badge-alert">
          <span>{offlineData?.length || 0}</span>
        </div>
      </button>
  )
}

export default SendOfflineData
